import { PriorityOption } from "@/graphql/generated"
import { SmallInfoCard } from "./SmallInfoCard"
import lowPriorityIcon from '@/assets/incidents-icons/low-priority-icon.svg'
import mediumPriorityIcon from '@/assets/incidents-icons/medium-priority-icon.svg'
import highPriorityIcon from '@/assets/incidents-icons/high-priority-icon.svg'
import { useUserLanguage } from "@/customHooks"

type IncidentPriorityMapperWithIconProps = {
  priorityOption: PriorityOption
  containerClassName?: string
}

const textsData = {
  en: {
    lowPriorityCard: {
      title: 'Priotity',
      value: 'Low'
    },
    mediumPriorityCard: {
      title: 'Priotity',
      value: 'Mid'
    },
    highPriorityCard: {
      title: 'Priotity',
      value: 'High'
    }
  },
  es: {
    lowPriorityCard: {
      title: 'Prioridad',
      value: 'Baja'
    },
    mediumPriorityCard: {
      title: 'Prioridad',
      value: 'Media'
    },
    highPriorityCard: {
      title: 'Prioridad',
      value: 'Alta'
    }
  }
}

export const IncidentPriorityMapperWithIcon = ({ priorityOption, containerClassName }: IncidentPriorityMapperWithIconProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  switch (priorityOption) {
    case PriorityOption.Low:
      return (
        <SmallInfoCard
          icon={lowPriorityIcon}
          title={texts.lowPriorityCard.title}
          value={texts.lowPriorityCard.value}
          containerClassName={containerClassName}
        />
      )
    
    case PriorityOption.Medium:
      return (
        <SmallInfoCard
          icon={mediumPriorityIcon}
          title={texts.mediumPriorityCard.title}
          value={texts.mediumPriorityCard.value}
          containerClassName={containerClassName}
        />
      )

    case PriorityOption.High:
      return (
        <SmallInfoCard
          icon={highPriorityIcon}
          title={texts.highPriorityCard.title}
          value={texts.highPriorityCard.value}
          containerClassName={containerClassName}
        />
      )

    default:
      return null
  }
}